import { useEffect, useState, useRef } from "react";
import { useApiClient } from "../../contexts/ApiClientContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import "leaflet/dist/leaflet.css";
import L from "leaflet";

import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import APIEndPoints from "../../utils/APIEndPoints";
import Loading from "../common/Loading";
import Site from "../../model/Site";
import PagedData from "../../model/PagedData";
import MapDisplay from "../common/map/MapDisplay";

function DashboardMap() {
  const authManager = useAuth();
  const navigate = useNavigate();
  const apiClient = useApiClient();
  const [data, setData] = useState<Site[]>([]);
  const [loading, setLoading] = useState(true);
  const [markers, setMarkers] = useState<
    {
      lat: number;
      lon: number;
      label: string;
      description?: string;
      site: Site;
    }[]
  >([]);

  const mapRef = useRef<L.Map | null>(null); // Store map reference

  useEffect(() => {
    apiClient
      ?.get<PagedData<Site[]>>({
        url: APIEndPoints.SITES.ALL,
        requiresToken: true,
      })
      .then((data: PagedData<Site[]>) => {
        setData(data.items);
        const markers = data.items
          .filter((site) => site.latitude != null && site.longitude != null)
          .map((site) => ({
            lat: site.latitude!,
            lon: site.longitude!,
            label: site.name,
            description: site.description,
            site: site,
          }));
        setMarkers(markers);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient]);

  if (loading) {
    return <Loading />;
  }

  return <div className="flex w-full h-[85vh]">DASHBOARD</div>;
}

export default DashboardMap;
